import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  gap: ${space['space-200']};
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};

  &[data-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Input = styled.input`
  appearance: none;
  box-sizing: border-box;
  width: ${size.icon['icon-md']};
  height: ${size.icon['icon-md']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.secondary};
  border-radius: ${size.radius['radius-xs']};
  margin: 0;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  background: ${semantic.bg.canvas};
  transition: background 0.15s ease, border-color 0.15s ease;

  &:checked {
    background: ${semantic.bg.positiveStrong};
    border-color: transparent;
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: 5px;
    left: 8px;
    width: 6px;
    height: 11px;
    border: solid ${semantic.text.inverse};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  &[data-indeterminate='true'] {
    background: ${semantic.bg.positiveStrong};
    border-color: transparent;
  }

  &[data-indeterminate='true']::after {
    content: '';
    position: absolute;
    top: 11px;
    left: 6px;
    width: 11px;
    height: ${primitives.size['size-050']};
    border: none;
    background: ${semantic.icon.inverse};
    transform: none;
  }

  &[data-error='true'],
  &[data-error='true']:checked {
    border-color: ${semantic.border.danger};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
